import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import classes from "../../Top/Top.module.scss";

// 投稿データに関するインターフェース
interface Post {
    id: number;
    title: { rendered: string };
    link: string;
  }

  const TopNews: React.FC<{ categoryId?: number; tagSlug?: string }> = ({ categoryId, tagSlug }) => {
    const [posts, setPosts] = useState<Post[]>([]);
    const location = useLocation();

    // パスから言語を取得
    const getLanguageFromPath = () => {
      const pathSegments = location.pathname.split('/');
      const langSegment = pathSegments.find(segment => segment === 'ja' || segment === 'en');
      return langSegment || 'ja'; // デフォルトは日本語
    };

    // 言語に応じたタグスラッグを取得
    const getTagSlugByLang = () => {
      return 'education';
    };

    // tagSlugが指定されていない場合は、言語に応じたデフォルトタグを使用
    const effectiveTagSlug = tagSlug || getTagSlugByLang();

    const stripHtml = (html: string) => {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
      };
    
      const limitText = (text: string, limit: number) => {
        const plainText = stripHtml(text);
        return plainText.length > limit ? plainText.substring(0, limit) + "..." : plainText;
      };
    
    useEffect(() => {
      const fetchPosts = async () => {
        const lang = getLanguageFromPath();
        // 言語に応じたベースURLを設定
        const baseUrl = lang === 'en' 
          ? 'https://hado-official.com/en/wp-json/wp/v2'
          : 'https://hado-official.com/wp-json/wp/v2';
        
        let url = `${baseUrl}/posts?per_page=100`;
        
        // タグスラッグが指定されている場合はタグで取得、そうでなければカテゴリIDで取得
        if (effectiveTagSlug) {
          // まずタグスラッグからタグIDを取得
          const tagResponse = await fetch(`${baseUrl}/tags?slug=${effectiveTagSlug}`);
          const tagData = await tagResponse.json();
          
          if (tagData && tagData.length > 0) {
            const tagId = tagData[0].id;
            url = `${baseUrl}/posts?tags=${tagId}&per_page=100`;
          }
        } else if (categoryId) {
          url = `${baseUrl}/posts?categories=${categoryId}&per_page=100`;
        }
        
        fetch(url)
          .then((response) => response.json())
          .then(async (data) => {
            // デバッグ: 取得したデータを確認
            console.log('TopNews - Fetched posts:', data.length);
            console.log('TopNews - Lang:', lang);
            console.log('TopNews - Base URL:', baseUrl);
            if (data.length > 0) {
              console.log('TopNews - First post link:', data[0].link);
            }

            // 言語に応じて記事をフィルタリング
            if (lang === 'en') {
              // 英語版の場合：取得した記事のリンクに/en/が含まれているか確認
              const englishPosts = data.filter((post: any) => {
                const postLink = post.link || '';
                return postLink.includes('/en/');
              });

              if (englishPosts.length > 0) {
                console.log('TopNews - Found English posts:', englishPosts.length);
                setPosts(englishPosts.slice(0, 3));
              } else {
                // 英語版の記事が見つからない場合、すべての記事を表示（フォールバック）
                console.log('TopNews - No English posts found in links, showing all posts');
                setPosts(data.slice(0, 3));
              }
            } else {
              // 日本語版の場合：/en/を含まず、/zh/も含まない記事（日本語記事）
              const filteredPosts = data.filter((post: any) => {
                const postLink = post.link || '';
                return !postLink.includes('/en/') && !postLink.includes('/zh/');
              });
              console.log('TopNews - Filtered posts:', filteredPosts.length);
              setPosts(filteredPosts.slice(0, 3));
            }
          })
          .catch((error) => console.error('Error fetching data:', error));
      };
      
      fetchPosts();
    }, [categoryId, effectiveTagSlug]);
  
    return (
      <ul className={classes.newsList}>
        {posts.map((post, index) => (
          <li key={index} className={classes.newsItem}>
            <Link to={`/${getLanguageFromPath()}/post/${post.id}`}>
            <p>{limitText(post.title.rendered, 100)} </p>
            </Link>
          </li>
        ))}
      </ul>
    );
  };
  

  export default TopNews;